import type React from 'react'
import { createContext } from 'react'

import { type useStore } from 'slab/hooks/useStore'

export interface TooltipState {
  openTooltipId: string | null;
}

export const DEFAULT_DELAY_DURATION = 500
export const DEFAULT_GRACE_PERIOD = 200

interface TooltipContextType {
  delayDuration: number;
  gracePeriod: number;
  onOpen: (tooltipId: string) => void;
  onClose: (tooltipId: string) => void;
  store: ReturnType<typeof useStore<TooltipState>>;
  wasAlreadyOpenRef: React.RefObject<boolean>;
}

export const TooltipContext = createContext<TooltipContextType>({
  delayDuration: DEFAULT_DELAY_DURATION,
  gracePeriod: DEFAULT_GRACE_PERIOD,
  onOpen: (_tooltipId: string) => {},
  onClose: (_tooltipId: string) => {},
  store: {
    setState: () => {},
    subscribe: () => () => {},
    snapshot: () => ({ openTooltipId: null }),
    emit: () => {},
  },
  wasAlreadyOpenRef: { current: false },
})
